import s from './TalentListBanner.module.css'
import { TalentList } from './TalentList'

const TalentListBanner = () => {
  return (
    <div className={s.wrapper}>
      <div className={s.contentContainer}>
        <div className={s.content}>
          <span className={s.sparkleTop}>&#10024;</span>
          <div>
            <span className={s.title}>TOP 3% TALENT</span>
            <span className={s.header}>
              Looking for the ultimate Creator match?
            </span>
          </div>
        </div>
        <span className={s.sparkle}>&#10024;</span>
      </div>
      <div className={s.images}>
        {[...TalentList, ...TalentList].map(talent => {
          return (
            <div className={s.card} key={talent.id}>
              <img className={s.image} src={talent.img} alt="light" />
              <div className={s.infoContainer}>
                <span className={s.name}>{talent.name}</span>
                <span className={s.role}>content writer</span>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default TalentListBanner
